import CelebratoryBlock, { CelebratoryBlockProps } from './CelebratoryBlock';

export type { CelebratoryBlockProps };
export default CelebratoryBlock;
